<template>
  <v-card>
    <CollapseItems :show="true">
      <template #title>
        <div class="mr-2">
          Guia da jornada
        </div>
      </template>
      <template #content>
        <Alert
          v-if="!hasSchedule"
          btn-text="Agendar horário de estudos"
          message="Uma das principais estratégias de estudos é definir o horário ideal para cumprir sua meta semanal. Você sabia que pode definir os melhores horários para vocês em nosso calendário?"
          :to="{
            name: calendarRouteName,
            query:{ show_create_schedule: true }
          }"
        />
        <Alert
          v-if="selectedCycle.count_modules > 0 && selectedCycle.is_finished"
          btn-text="Continuar estudos"
          message="Continue seus estudos"
          :to="{ name: studyNowRouteName }"
        />
        <Alert
          v-if="current_cycle.should_select_modules"
          btn-text="Selecionar módulos"
          message="Escolha seus módulos para o ciclo atual"
          :to="{ name: selectModulesRouteName }"
        />
        <Alert
          v-if="shouldAccessFirstModule"
          :message="`Comece por acessar o primeiro módulo do ciclo ${currentCycleOrder} : ${unfinishedModulesOnCurrentCycle[0].name}`"
          :to="{
            name: showModuleRouteName,
            params:{
              module_id: unfinishedModulesOnCurrentCycle[0].id,
            }
          }"
        />
        <Alert
          v-if="lastModuleIsUncompleted"
          :message="'Continue a acessar o módulo: ' + lastModule.name"
          :to="{
            name: showModuleRouteName,
            params:{
              module_id: lastModule.id
            }
          }"
        />
        <Alert
          v-if="lastModuleIsFinished"
          message="Já que você concluiu o último módulo acessado, que tal continuar os estudos por um novo módulo?"
          :to="{
            name: showModuleRouteName,
            params:{
              module_id: recomendedModuleId
            },
          }"
        />

        <Alert
          v-if="show_challenge_notice"
          message="Agora que você já concluiu todos os módulos que escolheu, que tal realizar o desafio do ciclo e testar seus conhecimentos?"
          :btn-text="hasChallengeRunning ? 'Continuar Desafio' : 'Realizar desafio'"
          type="challenge"
          :to="{
            name: studyNowRouteName,
            query:{
              show_challenge_modal: hasChallengeRunning ? true : false
            }
          }"
        >
          <v-btn
            v-if="hasChallengeRunning"
            color="challenge"
          >
            <Timer :time="$moment(current_cycle.challenge.started_at).add(current_cycle.challenge.minutes, 'minutes').valueOf()" />
          </v-btn>
        </Alert>

        <Alert
          v-if="has_uncompleted_contents_after_completed_modules"
          message="Você tem novos conteúdos nos seus módulos, que tal aprimorar seus conhecimentos?"
          btn-text="Visualizar módulo"
          type="module"
          :to="{
            name: showModuleRouteName,
            params:{
              module_id: completedModulesWithUncompletedContents[0].id
            },
          }"
        />
      </template>
    </CollapseItems>
  </v-card>
</template>
<script>
import {mapGetters} from "vuex";
import Timer from "../components/challenge/Timer.vue";
import Alert from "./Notice/Alert.vue";
import CollapseItems from "@/common/components/CollapseItems.vue";
import { studyNowRouteName, selectTrailRouteName, calendarRouteName, selectModulesRouteName } from "@/student/constants/routes"
import { showModuleRouteName } from "../constants/routes";

export default {
  components: {
    CollapseItems,
    Timer,
    Alert,
  },
  data(){
    return {
      remaining: 1000,
      studyNowRouteName,
      calendarRouteName,
      selectTrailRouteName,
      selectModulesRouteName,
      showModuleRouteName,
    }
  },
  computed: {
    ...mapGetters([
      'current_cycle',
      'currentCycleOrder',
      'unfinishedModulesOnCurrentCycle',
      'hasUnfinishedModulesOnCurrentCycle',
      'currentCycleHasModules',
      'currentCycleHasAllModuleCompleted',
      'currentCycleUnfinishedChallenges',
      'currentCycleHasUnfinishedChallenges',
      'lastRecommendedModule',
      'firstUnfinishedModulesOnCurrentCycle',
      'lastUnfinishedRecommendedModules',
      'lastModule',
      'hasSchedule',
      'hasChallengeRunning',
      'lastModuleIsFinished',
      'currentCycleIsFinished',
      'completedModulesWithUncompletedContents',
      "isOnVacation",
      'selectedCycle'
    ]),
    show_challenge_notice(){
      return !this.currentCycleIsFinished 
      && this.current_cycle.challenge_type == 'online' 
      && this.selectedCycle.challenge_released
      && (!this.current_cycle.challenge?.finished_at ?? true)
    },
    lastModuleIsUncompleted(){
      return !this.lastModuleIsFinished && this.currentCycleHasModules && this.lastModule;
    },
    shouldAccessFirstModule(){
      return !this.lastModule && this.hasUnfinishedModulesOnCurrentCycle;
    },
    recomendedModuleId(){
      return this.lastRecommendedModule ? this.lastUnfinishedRecommendedModules[0].module_id : this.firstUnfinishedModulesOnCurrentCycle?.id;
    },
    has_uncompleted_contents_after_completed_modules(){
      return this.completedModulesWithUncompletedContents.length > 0
    },
    caseRulesList(){
      return [
        this.show_challenge_notice,
        !this.hasSchedule,
        !this.currentCycleHasModules,
        this.shouldAccessFirstModule,
        this.lastModuleIsFinished && !this.currentCycleHasAllModuleCompleted,
        this.lastModuleIsUncompleted,
        this.has_uncompleted_contents_after_completed_modules,
        this.selectedCycle.count_modules > 0 && this.selectedCycle.is_finished
      ];
    },
  }
}
</script>
